<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6 max-w-3xl mx-auto">
  <h1 class="text-2xl font-bold text-gray-900 mb-2">Vendor onboarding</h1>
  <p class="text-gray-600 text-sm mb-6">
    <strong>Invite</strong> sends login credentials by email (like organization invite). <strong>Profile only</strong> stores company details without a user account — use invite for full access.
  </p>

  <div class="flex gap-2 mb-6">
    <button
      type="button"
      (click)="tab = 'invite'"
      [class]="tab === 'invite' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 border'"
      class="px-4 py-2 rounded-lg text-sm font-medium"
    >
      Invite vendor
    </button>
    <button
      type="button"
      (click)="tab = 'profile'"
      [class]="tab === 'profile' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 border'"
      class="px-4 py-2 rounded-lg text-sm font-medium"
    >
      Create profile only
    </button>
  </div>

  <div *ngIf="tab === 'invite'" class="bg-white rounded-xl shadow border border-gray-200 p-6 space-y-4">
    <form [formGroup]="inviteForm" (ngSubmit)="submitInvite()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Company name *</label>
        <input class="w-full border rounded-lg px-3 py-2" formControlName="company_name" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Primary email *</label>
        <input class="w-full border rounded-lg px-3 py-2" type="email" formControlName="primary_contact_email" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Contact name</label>
        <input class="w-full border rounded-lg px-3 py-2" formControlName="primary_contact_name" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Phone</label>
        <input class="w-full border rounded-lg px-3 py-2" formControlName="primary_contact_phone" />
      </div>
      <button type="submit" class="w-full sm:w-auto px-6 py-2 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700">
        Send invite
      </button>
    </form>
  </div>

  <div *ngIf="tab === 'profile'" class="bg-white rounded-xl shadow border border-gray-200 p-6 space-y-4">
    <form [formGroup]="profileForm" (ngSubmit)="submitProfile()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Company name *</label>
        <input class="w-full border rounded-lg px-3 py-2" formControlName="company_name" />
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">GST</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="gst_number" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">PAN</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="pan_number" />
        </div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Address line 1</label>
        <input class="w-full border rounded-lg px-3 py-2" formControlName="address_line_1" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Address line 2</label>
        <input class="w-full border rounded-lg px-3 py-2" formControlName="address_line_2" />
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">City</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="city" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">State</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="state" />
        </div>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Postal code</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="postal_code" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Country</label>
          <input class="w-full border rounded-lg px-3 py-2" formControlName="country" />
        </div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Availability status</label>
        <select class="w-full border rounded-lg px-3 py-2" formControlName="availability_status">
          <option value="available">available</option>
          <option value="limited">limited</option>
          <option value="unavailable">unavailable</option>
        </select>
      </div>
      <button type="submit" class="w-full sm:w-auto px-6 py-2 rounded-lg bg-slate-800 text-white font-medium hover:bg-slate-900">
        Save profile
      </button>
    </form>
  </div>
</div>
